import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconSidebarRightShow12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2H8v8h2.5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m-9 0H7v8H1.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5m0-1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h9A1.5 1.5 0 0 0 12 9.5v-7A1.5 1.5 0 0 0 10.5 1zm3.839 3.586a.5.5 0 1 0-.707-.707L2.864 5.646 2.51 6l.354.354L4.632 8.12a.5.5 0 1 0 .707-.707L3.925 6z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow12);
